
import React, { Component } from 'react';
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { MAX_AD_TIME } from '../services/ABeCProperties'
import adService from './service/adService';
import VizSensor from 'react-visibility-sensor';
import abecPages from '../services/abecPages';
import styles from './styles/advertise.module.css';
import largeRectangle from '../../assets/largeRectangle.png'

class LargeRectangle extends Component {

    constructor(props) {
        super(props);
        this.currentAd = {};
        this.seconds = 0;
        this._isMounted = false;
        this.state = {
            ad: {
                adLink: '',
            },
            isComponentVisible: false,
            viewed: {},
        };
    }

    isEmpty = (obj) => {
        for (var key in obj) {
            if (obj.hasOwnProperty(key))
                return false;
        }
        return true;
    }

    componentWillUnmount() {
        clearInterval(this.timer);
        this.updateVisibleAds(false)
        this._isMounted = false;
        //this.seconds = 0;
    }

    componentDidMount() {
        this._isMounted = true;
        this.props.sendlargeRectangle([])
    }

    componentDidUpdate(prevProps, prevState) {
        const page = abecPages.getPageName(this.props.match.path)
        const isComponentVisible = this.state.isComponentVisible !== prevState.isComponentVisible && this.state.isComponentVisible;
        if (isComponentVisible && this.isEmpty(this.currentAd)) {
            if (page === "ListingPage" || page === "ShareClipPage") {
                this.getListingAds()
            } else if (page === "LookupPage" || page === "ClipPage") {
                this.getAdsBySearch()
            } else {
                this.getAds(page)
            }
        }

        const visiblityPropChanged = this.state.isComponentVisible !== prevState.isComponentVisible || this.props.isPageVisible !== prevProps.isPageVisible || this.props.isPopupOpen !== prevProps.isPopupOpen
        if (this.state.ad.id && visiblityPropChanged) {
            if (this.state.isComponentVisible && this.props.isPageVisible && !this.props.isPopupOpen)
                this.startTimer()
            else
                this.stopTimer()
        }
    }

    getListingAds = () => {
        console.log("Yes")
        if (this.props.search_data.loadAds)
            adService.getAdsByListing(this.props.search_data, "largeRectangle").then(response => {
                if (this.state.isComponentVisible && this.props.isPageVisible && !this.props.isPopupOpen && this.isEmpty(this.currentAd))
                    if (this.props.viewedAds.length < 135) {
                        this.showAdvertisement(response)
                    }
            })
        else {
            if (this.timer)
                this.stopTimer();
            this.currentAd = {};
        }
    }

    getAdsBySearch = () => {
        // fetch ads based on search query entered by user
        adService.getAdsBySearch(this.props.search_data, 'largeRectangle').then(response => {
            if (this.state.isComponentVisible && this.props.isPageVisible && this.isEmpty(this.currentAd)) {
                if (this.props.viewedAds.length < 135) {
                    this.showAdvertisement(response)
                }
            }
        })
    }

    getAds = (page) => {
        this.setState({
            ad: {
                adLink: ''
            }
        })
        adService.getAdvrtsByPageTypeAndLocation(this.props.current_coords, page, 'largeRectangle')
            .then(response => {
                if (this.state.isComponentVisible && this.props.isPageVisible && this.isEmpty(this.currentAd))
                    if (this.props.viewedAds.length < 135) {
                        this._isMounted && this.showAdvertisement(response)
                    }
            })
    }
    showAdvertisement = (ads) => {
        const storedLrAd = JSON.parse(sessionStorage.getItem('largeRectangle' + this.props.spot))

        const pageName = abecPages.getPageName(this.props.match.path);
        this.props.storedLR.forEach(e => {
            const ad = JSON.parse(sessionStorage.getItem(e));
            if (ad && ad.page !== pageName)
                sessionStorage.removeItem(e);
        })
        if (storedLrAd && storedLrAd.page === abecPages.getPageName(this.props.match.path)) {
            //sessionStorage.setItem(key, JSON.stringify([...this.props.storedLR]))
            this.setState({ ad: storedLrAd, viewed: { [storedLrAd.id]: this.props.viewedAds.includes(storedLrAd.id + ":largeRectangle") } })
            this.seconds = 30;

        } else if (!this.isEmpty(ads[0]) || ads[0]) {
            this.currentAd = ads.splice(0, 1)[0];
            this.currentAd.adLink = process.env.REACT_APP_IMAGES_URL + this.currentAd.advertisement;
            let loadedLR = [...this.props.largeRectangleAds]
            if (!loadedLR.includes(this.currentAd.id) && !this.props.viewedAds.includes(this.currentAd.id + ":largeRectangle")) {
                this._isMounted && this.setState({ ad: this.currentAd })
                loadedLR.push(this.currentAd.id)
                this.props.sendlargeRectangle(loadedLR)
                sessionStorage.removeItem('largeRectangle' + this.props.spot)
            } else
                this.showAdvertisement(ads);
            this.seconds = 0;
            this.startTimer()
            sessionStorage.removeItem('largeRectangle' + this.props.spot)
        } else if (!this.state.ad.id) {
            sessionStorage.removeItem('largeRectangle' + this.props.spot)
            this._isMounted && this.setState({
                ad: {
                    adLink: ''
                }
            })
        }
    }

    startTimer = () => {
        if (this.timer)
            this.stopTimer();
        if (this.currentAd.id && this.seconds <= MAX_AD_TIME) {
            this.timer = setInterval(() => {
                this.seconds += 1;
                if (this.seconds > MAX_AD_TIME) {
                    this.stopTimer();

                    this.currentAd.page = abecPages.getPageName(this.props.match.path)
                    const key = "largeRectangle" + this.props.spot;
                    sessionStorage.setItem(key, JSON.stringify(this.currentAd))
                    this.updateViews(this.state.ad.id);
                    const storedLrAds = [...this.props.storedLR]
                    storedLrAds.push(key)
                    this.props.setStoredLRAds(storedLrAds);
                }
            }, 1000);
        }
        if (this.seconds = 1) {
            this.updateAdDisplay(this.state.ad.id)
        }
    }

    stopTimer = () => {
        clearInterval(this.timer);
    }

    updateVisibleAds = (isComponentVisible) => {
        const adName = "largeRectangle" + this.props.spot
        if (isComponentVisible && !this.props.visibleAds.includes(adName)) {
            this.props.setVisibleAds([...this.props.visibleAds, adName])
        } else if (!isComponentVisible && this.props.visibleAds.includes(adName)) {
            this.props.setVisibleAds(this.props.visibleAds.filter(e => e !== adName))
        }
    }

    updateAdDisplay = (id) => {
        let listingData = {
            viewedOnListing: null,
            section: null,
        }
        if (this.props.search_data.listingId) {
            listingData = {
                viewedOnListing: parseInt(this.props.search_data.listingId),
                section: this.props.search_data.place,
            }
        }
        adService.updateAdDisplay(id, 'largeRectangle', listingData).then(result => {
            this._isMounted && this.setState({ section: { [id]: result } })
        })
    }

    updateViews = (id) => {
        let listingData = {
            viewedOnListing: null,
            viewed: null,
            section: null,
        }
        if (this.props.search_data.listingId) {
            listingData = {
                viewedOnListing: parseInt(this.props.search_data.listingId),
                viewed: this.props.search_data.isViewed,
                section: this.props.search_data.place,
            }
        }
        adService.updateViews(id, 'largeRectangle', listingData).then(result => {
            this._isMounted && this.setState({ viewed: { [id]: result } })
        })
        this.props.sendViewedAds(id + ":largeRectangle");
    }

    render() {
        const page = abecPages.getPageName(this.props.match.path)
        return (
            <VizSensor
                onChange={(isVisible) => {
                    if (this.state.isComponentVisible !== isVisible) {
                        this.setState({ isComponentVisible: isVisible })
                        this.updateVisibleAds(isVisible)
                    }
                }}
                partialVisibility

                offset={
                    { top: 300, bottom: 125 }
                }
            >
                <div className={`items_list ${styles.largeRectAd}`}>
                    <div className={styles.ad_position}>
                        <strong className="ad_mark">AD</strong>
                    </div>
                    {(!this.isEmpty(this.state.ad) && this.state.ad.mediaType === 'video')
                        ?
                        <video className={`img-fluid ${this.state.ad.website ? 'cursor_pointer' : ''}`}
                            onClick={() => adService.redirect(this.state.ad.website)}
                            autoPlay={true} loop src={this.state.ad.adLink !== '' ? this.state.ad.adLink : largeRectangle} type="video/mp4" onLoad={this.handleImageLoad} muted>
                        </video>
                        :
                        <img className={`img-fluid ${this.state.ad.website ? 'cursor_pointer' : ''}`} id={"large-rectangle" + this.props.spot} loading='lazy' width='336' height='280'
                            onClick={() => adService.redirect(this.state.ad.website)}
                            src={this.state.ad.adLink !== '' ? this.state.ad.adLink : largeRectangle} alt="large Rectangle Ad" />
                    }
                    <div className={styles.ad_position}>
                        {(this.state.viewed[this.state.ad.id]) ? <i className="fas fa-check-circle viewed_mark"></i> : null}
                    </div>
                </div>
            </VizSensor>
        )
    }
}

const mapStateToProps = state => {
    return {
        largeRectangleAds: state.largeRectangleAds,
        isPopupOpen: state.isPopupOpen,
        current_coords: state.current_coords,
        search_data: state.search_data,
        isPageVisible: state.isPageVisible,
        viewedAds: state.viewedAds,
        visibleAds: state.visibleAds,
        storedLR: state.storedLR,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        sendlargeRectangle: (largeRectangleAds) => dispatch({ type: 'LARGE_RECTANGLE_ADS', largeRectangleAds: largeRectangleAds }),
        sendViewedAds: (viewedAds) => dispatch({ type: 'VIEWED_ADS', viewedAds: viewedAds }),
        setVisibleAds: (visibleAds) => dispatch({ type: 'VISIBLE_ADS', visibleAds: visibleAds }),
        setStoredLRAds: (storedLR) => dispatch({ type: 'STORED_LR_ADS', storedLR: storedLR })
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LargeRectangle));
